import { render } from "./Index.vue?vue&type=template&id=391c1520"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=391c1520&lang=scss"

import exportComponent from "/home/jenkins/workspace/xujiaxin-linchuang-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__